import { Avatar, SxProps } from '@mui/material';
import { memo } from 'react';

import { User } from '../../../features/users/types';

type UserAvatarProps = {
  user: User;
  size?: number;
  sx?: SxProps;
};

const getInitials = (name: string): string => {
  if (!name || name.trim() === '') return '?';

  const parts = name.trim().split(/\s+/);

  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }

  const firstInitial = parts[0][0];
  const lastInitial = parts[parts.length - 1][0];

  return (firstInitial + lastInitial).toUpperCase();
};

/* eslint-disable react/prop-types */

const UserAvatar = memo<UserAvatarProps>(({ user, size = 40, sx }) => {
  const hasProfilePicture = user.profilePicture && user.profilePicture.trim() !== '';

  if (hasProfilePicture) {
    return (
      <Avatar
        src={user.profilePicture}
        alt={`Foto de perfil de ${user.name}`}
        sx={{ width: size, height: size, ...sx }}
      />
    );
  }

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        bgcolor: '#ff3700',
        color: '#fff',
        fontWeight: 'bold',
        fontSize: size * 0.4,
        ...sx
      }}
    >
      {getInitials(user.name)}
    </Avatar>
  );
});

UserAvatar.displayName = 'UserAvatar';

export default UserAvatar;
